export default __webpack_public_path__ + "static/Yaroslav Reshetnyk-d658bb587cffcafa82572a2380f64e29.png";